import { AllParams } from "@gumtree/shared/src/types/advertising/partnership";

type State = AllParams;

const initialState = {} as State;

export const UPDATE_PARTNERSHIPS = 'UPDATE_PARTNERSHIPS';

export const updatePartnerships = (payload) => ({
    type: UPDATE_PARTNERSHIPS,
    payload,
});

export default (state = initialState, action): State =>
    action.type === UPDATE_PARTNERSHIPS ? { ...state, ...action.payload } : state;
